module.exports = __webpack_public_path__ + "static/media/uzj100-landcruiser.8e3e51a5.jpg";